import { render, staticRenderFns } from "./TypeThree.vue?vue&type=template&id=58490e88&"
import script from "./TypeThree.vue?vue&type=script&lang=js&"
export * from "./TypeThree.vue?vue&type=script&lang=js&"
import style0 from "./TypeThree.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports